import axios from 'axios';
import utilsStorage from '@/utils/storage';
import logService from '@/services/logService';

async function loadConfig() {
  try {
    const response = await fetch('/config.json');

    if (!response.ok) {
      throw new Error('Network response was not ok');
    }

    return await response.json();
  } catch (error) {
    logService.error('Não foi possível carregar a configuração:', error);

    return {}; // Retorne um objeto vazio ou algum fallback
  }
}

async function login(user) {
  user = user || {};

  const config = await loadConfig();

  return new Promise((resolve, reject) => {
    return axios
      .post(`${config.urlApiAuth}/login`, { email: user.email, password: user.password })
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  });
}

async function changePassword(password) {
  const token = utilsStorage.getTokenOnStorage();

  const config = await loadConfig();

  return new Promise((resolve, reject) => {
    return axios
      .put(`${config.urlApiAuth}/change-password`, {
        password
      }, { headers: { Authorization: token } })
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  });
}

async function validateUserByCode(email, code) {
  const config = await loadConfig();

  return new Promise((resolve, reject) => {
    return axios
      .post(`${config.urlApiAuth}/code-login`, {
        email,
        code
      })
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  });
}

/* Provedores de identidade (Google e futuros) — rotas públicas do authenticator. */

/** Provedores ligados nesta instalação: [{ name, label, uiType, ...configuração pública }] */
async function getIdentityProviders() {
  const config = await loadConfig();

  return axios.get(`${config.urlApiAuth}/identity/providers`);
}

/** Passo inicial do provedor (Google: nonce do login). */
async function startIdentityProvider(provider) {
  const config = await loadConfig();

  return axios.post(`${config.urlApiAuth}/identity/${encodeURIComponent(provider)}/start`, {});
}

/** Prova do provedor → credenciais, ou { linkRequired, ticket, email, name } na primeira vez. */
async function loginWithIdentityProvider(provider, proof) {
  const config = await loadConfig();

  return axios.post(`${config.urlApiAuth}/identity/${encodeURIComponent(provider)}/login`, proof);
}

/** Primeira vez: vincula a conta do provedor ao acesso de e-mail e senha e entra. */
async function linkIdentity(provider, { ticket, email, password }) {
  const config = await loadConfig();

  return axios.post(`${config.urlApiAuth}/identity/${encodeURIComponent(provider)}/link`, { ticket, email, password });
}

export default {
  login,
  changePassword,
  validateUserByCode,
  getIdentityProviders,
  startIdentityProvider,
  loginWithIdentityProvider,
  linkIdentity
};
